/* eslint-disable no-undef */
/* eslint-disable react/react-in-jsx-scope */
import { NavLink,
    //  Link, 
    //  Outlet,
} from "react-router";
import { useState, useEffect } from 'react'
// import { PowerIcon } from '@heroicons/react/24/outline';
import {
  // UserGroupIcon,
  HomeIcon,
  // DocumentDuplicateIcon,
} from '@heroicons/react/24/outline';
import { ChevronRightIcon, ArrowRightCircleIcon,
  IdentificationIcon,
  ClipboardDocumentCheckIcon, CurrencyDollarIcon, TruckIcon ,
  DocumentChartBarIcon, WalletIcon,
  } from "@heroicons/react/16/solid";
import { useUserContext, useUserDispatch, } from '../contexts/UserContext';
import { useNavigate } from "react-router";
import axios from 'axios';

import "./PosSidebar.css"

// const links = [
//   { name: 'All Product', href: '/pos/products', icon: UserGroupIcon },
//   { name: 'Cakes', href: '/pos/products/Cakes', icon: UserGroupIcon },
//   { name: 'Chiffon', href: '/pos/products/Chiffon', icon: UserGroupIcon },
//   { name: 'Bakery', href: '/pos/products/Bakery', icon: UserGroupIcon },
//   { name: 'เค้ก', href: '/pos/products/เค้ก', icon: UserGroupIcon },
//   { name: 'ชิฟฟ่อน', href: '/pos/products/ชิฟฟ่อน', icon: UserGroupIcon },
//   { name: 'วัฟเฟอร์', href: '/pos/products/วัฟเฟอร์', icon: UserGroupIcon },
//   { name: 'วุ้น', href: '/pos/products/วุ้น', icon: UserGroupIcon },
//   { name: 'ขนมปัง', href: '/pos/products/ขนมปัง', icon: UserGroupIcon },
//   { name: 'ทั่วไป', href: '/pos/products/ทั่วไป', icon: UserGroupIcon },
//   // { name: 'Users', href: '/users', icon: UserGroupIcon },
//   // { name: 'user', href: '/users/1', icon: UserGroupIcon },
//   // { name: 'userlist', href: '/users/user', icon: UserGroupIcon },

// ];

const AdminMenu = [
  // { name: 'Dashboard', href: '/pos', icon: HomeIcon },
  // {
  //   name: 'Reports',
  //   href: '/reports',
  //   icon: DocumentChartBarIcon ,
  // },

  // {
  //   name: 'Invoices',
  //   href: '/pos/invoices',
  //   icon: CurrencyDollarIcon ,
  // },
  {
    name: 'Users',
    href: '/users',
    icon: IdentificationIcon ,
  },
  { name: 'Products', href: '/products', icon: TruckIcon  },
  { name: 'Stocks', href: '/products/stocks', icon: ClipboardDocumentCheckIcon  },
];


function PosSidebar() {
  const userCon = useUserContext();
  const dispatch = useUserDispatch(); 
  const navigate = useNavigate();
  const [category, setCategory] = useState([])


  const apiurl = `${process.env.REACT_APP_API}/products.php`

  const handleLogout = () => {
    //
    dispatch({
        type: 'logout',
      });

      navigate("/");    
  }

  const fetchCategory = async () => {
    try {
      const result = await axios.get(`${apiurl}?mode=getcategory`);
      
      // console.log(result);
      // console.log(result.data);
      // if(result.data.length>0) {
      if(result.data && result.data[0].length>0) {  
        // const data = await response.json();
        // console.log(result.data[0]);
        setCategory(result.data[0]);
        return result.data[0];
      }

    }
    catch(err) {
        console.log(err);
      }
    }

// useEffect(() => {
//   if(user?.user?.isAdmin < 1 ) {  // Role !== 'Admin'
//     navigate("/")
//   }}) 
  
useEffect(() => {

  fetchCategory();
  
},[])


  return (
        <div className="flex items-stretch justify-between  h-[calc(100vh-120px)]  w-[150px] flex-col px-0 py-2" >
            <div className="flex justify-center space-x-1 flex-col space-y-1">
              {/* <div className="flex w-full justify-center">
                <div className="flex w-20 h-20 justify-center rounded-full p-1 bg-green-500">
                        <img
                          alt={userCon.user?.name}
                          src={`https://pos.freelance.in.th/image/users/avatar2.png`}
                          className="rounded-full"
                        />
                </div>       
             </div>  
                <div className="flex justify-center px-2 text-white">
                  {userCon.user?.name}
                </div> */}
                <div className="flex flex-col  justify-center p-2 gap-y-2">
                 {userCon.user?.isAdmin==1 && 
                    AdminMenu.map((menu) => {
                      const LinkIcon = menu.icon;
                      return (
                          <NavLink
                          key={menu.name}
                          to={menu.href} 
                          className='flex h-[28px] grow items-center justify-start  gap-2 rounded-md bg-gray-100 p-3 text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600   px-3'
                          end
                          >
                          <LinkIcon className="w-4" />
                          <p className="block">{menu.name}</p>
                          </NavLink>
                      );
                    })
                 }
                <NavLink
                  key="reservefunds"
                  to="/reservefunds" 
                  className='flex h-[28px] grow items-center justify-start  gap-2 rounded-md bg-gray-100 p-3 text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600   px-3'
                  end
                  >
                  <WalletIcon className="h-4 w-4" />
                  <p className="block">เงินสำรองจ่าย</p>
                </NavLink>

                 <hr />
                 <NavLink
                    key="AllProduct"
                    to="/pos/products" 
                    className='flex h-[28px] grow items-center justify-start  gap-2 rounded-md bg-gray-100 p-3 text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600   px-3'
                    end
                    >
                    <ArrowRightCircleIcon  className="w-4" />
                    <p className="block">All Product</p>
                  </NavLink>
                 {category?.map((cat) => {
                  return (
                      <NavLink
                        key={cat.category}
                        to={`/pos/products/${cat.category}`} 
                        className='flex h-[28px] grow items-center justify-start  gap-2 rounded-md bg-gray-100 p-3 text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600   px-3'
                        end
                        >
                        {/* <ChevronRightIcon className="h-6 w-6 text-gray-500" /> */}

                        <ChevronRightIcon className="w-4" />
                        <p className="block">{cat.category}</p>
                      </NavLink>
                  );
                  })}

                  {/* {links?.map((link) => {
                  const LinkIcon = link.icon;
                  return (
                      <NavLink
                        key={link.name}
                        to={link.href} 
                        className='flex h-[28px] grow items-center justify-start  gap-2 rounded-md bg-gray-100 p-3 text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600   px-3'
                        end
                        >
                        <LinkIcon className="w-4" />
                        <p className="block">{link.name}</p>
                      </NavLink>
                  );
                  })} */}
                </div>
            </div>
                <div className="flex p-2">
                   <button className="w-full p-2 text-white bg-teal-700 rounded-md hover:bg-teal-400"
                    onClick={handleLogout}>
                      Logout
                   </button>
                </div>

        </div>
    )
}

export default PosSidebar